// eslint-disable-next-line import/prefer-default-export
export const ADMIN_EN = {
  // Datos para Enviar el NPS
  sendNps: 'Send NPS',
  textH1: 'Select NPS template to send?',
  // Common actions and words
  Accept: 'Accept',
  Cancel: 'Cancel',
  Save: 'Save',
  Delete: 'Delete',
  Edit: 'Edit',
  Update: 'Update',
  Vacancy: 'Vacancy',
  Add: 'Add',

  // MAIN SIDENAV
  CandidatesBase: 'Candidates database',
  Analytics: 'Analytics',
  GeneralAdmin: 'General admin',
  Multiposting: 'Multiposting',
  Invoices: 'Invoices',
  DataStudio: 'Data studio',
  GeneralAnalytics: 'General analytics',

  // ////////////////////////////////
  // ADMIN
  GeneralStep: 'General',
  VisualEditorStep: 'Visual Editor',
  UsersStep: 'Users',
  MailingStep: 'Mailings',
  newAccounts: 'New accounts',

  // general step
  GeneralGenStep: 'General',
  APIGenStep: 'Integrations',
  PaymentsGenStep: 'Payments',
  TemplatesGenStep: 'Templates',
  Industry: 'Industry',
  industryMessage: 'Choose the industry of your enterprise.',
  spontaneousVacancy: 'Spontaneous vacancy',
  spontaneousVacancyMessage:
    "Vacancies to which applicants could apply, you will be able to see their CV's and trasfer them to a vacany of your interest. ",
  acceptSpontaneous: 'Accept spontaneous vacancy',
  English: 'English',
  Spanish: 'Spanish',
  Language: 'Language',
  selectLanguageMessage: 'Choose the language that you prefer to work in.',
  // Api page
  SelfHostingMessage: 'Type the subdomain',
  TooltipSubdomain: 'Main subdomain in which our platform data will be loaded.',
  placeholderSubdomain: 'Subdomain',
  Integrations: 'Integrations',
  ImplementationWithThePlatform: 'Implementation with the platform',
  SlackOptions: 'Slack options',
  TeamsOptions: 'Teams options',
  BambooIntegration: 'BambooHR integration',
  BambooMessage:
    'In order to integrate BambooHR with the platform, we need your domain and an admin API key, please insert them below: ',
  Domain: 'Domain: ',
  ApiKey: 'API Key:',
  HowToGetTheKey: 'How to get the BambooHR API key?',
  WhichIntegrationMode: "When do you want to import your applicants' info to BambooHR?",
  WhenAccepted: 'When the applicant is accepted',
  WhenApplied: 'When the applicant applies',
  Instruction1: '1. Log in into your BambooHR domain: ',
  Instruction2: '2. Click your name in the upper right-hand corner to get to the user context menuPop.',
  Instruction3: '3. Click the "API Keys" option (You must have admin permissions to have this option available).',
  Instruction4: "4. Type a name for the key and click 'Generate key'. Copy and store the key.",
  ComingSoon: 'Coming soon!',
  // Payments page
  StartupMessage: 'Your Startup plan is free',
  ProfessionalMessage1: 'Your',
  ProfessionalMessage2: 'plan will be renewed on: ',
  ChangePlan: 'Change plan',
  ChargeLimit: 'Monthly charge limit',
  SendInvoicesTo: 'Send invoices to:',
  SomeOfOurBenefits: 'Some of our benefits',
  benefit1: 'Multiposting in +100 institutes',
  benefit2: 'Custom Careers page',
  benefit3: 'Personalized hard skills',
  benefit4: 'Applicants testing',
  PaymentMethod: 'Payment method',
  AddCard: 'Add credit / debit card',
  UpdateCard: 'Update credit / debit card',
  Cardholder: 'Cardholder',
  CardInfo: 'Card info',
  BillingInfo: 'Billing info',
  FullName: 'Full name',
  TaxpayerNumber: 'Taxpayer number',
  Adress: 'Adress',
  City: 'City',
  ZipCode: 'ZIP code',
  BillingNotes: 'Billing notes',
  // Templates page
  Templates: 'Templates',
  Columns: 'Columns',
  SearchTemplates: 'Search templates',
  CreateTemplate: 'Create new template',
  CreatedBy: 'Created by',
  TemplateName: 'Template name',
  CreatedAt: 'Created at',
  Type: 'Type',
  Actions: 'Actions',
  tooltipDeleteColumn: 'Delete column',
  tooltipMoveColumn: 'Move column',
  tooltipAddAdmins: 'Add admins',
  // modalDeleteTemplate
  DeleteTemplateHeader: 'Delete template',
  DeleteTemplateConfirmation: 'Are you sure you want to delete this template?',
  DeleteTemplateWarning: 'Deleted templates cannot be recuperated.',
  // modalCreateTemplate
  CreateTemplateHeader: 'Create column template',
  NewApplicants: 'New applicants',
  RejectedApplicants: 'Rejected',
  AcceptedApplicants: 'Accepted',
  AddColumn: 'Add column',
  TemplateActive: 'Active',
  placeholderTemplateName: 'Template name',
  NewTemplate: 'New template',

  // Visual Editor
  imgVacancy: 'Img. vacancy',
  Watch: 'Watch',
  Help: 'Help',
  AboutUs: 'About us',
  Employment: 'Employment',
  Location: 'Location',
  OurTeam: 'Our team',
  Installations: 'Installations',
  OurCulture: 'Our Culture',
  OurInstallationsAndPerks: 'Our Installations and Perks',
  MainText: 'Main text',
  Office: 'Office',
  AddImageHeader: 'Add an image for vacancies',
  PredefinedImageMessage: 'This will be the predefined image when creating new jobs',
  tooltipEditImage: 'Edit image',
  tooltipEditText: 'Edit text',
  tooltipEditTeam: 'Edit team',
  tooltipEditCulture: 'Edit culture',
  tooltipEditOffices: 'Edit offices',
  NoInfo: 'There is no info at the moment',
  Background: 'Background',
  EditPage: 'Edit page',
  ChangeMainTitle: 'Change main title',
  ChangeTitle: 'Change title',
  ChangeDescription: 'Change description',
  ChangeText: 'Change text',
  ChangeSubtitle: 'Change subtitle',
  TellUsMore: 'Tell us more',
  CollaboratorName: "Collaborator's name",
  ImgOrVideo: 'Image or video',
  Post: 'Post',
  PhotoUrl: 'Photo or video url',
  ExecutiveTeam: 'Executive Team',

  // User Admin
  AddUser: 'Add user',
  SearchBy: 'Search by name',
  AllDepartments: 'All',
  adminType: 'Has all permissions and full access to the platform.',
  recruiterType:
    'Same as Admin, except for "General Admin" section, which includes features such as Integrations, Payments, and Mailing.',
  userType: 'Limited access. Can only see vacancies for which access was given.',
  Recruiter: 'Recruiter',
  User: 'User',
  // modalConfirmation
  DeleteUser: 'Delete user',
  Warning: 'This action cannot be reverted',
  PleaseType: 'Please type ',
  ToConfirm: ' to confirm: ',
  // modalDepartment
  AddDepartment: 'Add department',
  PlaceholderAddDepartment: 'Add / Edit department',
  // modalAddUser
  UploadAPhoto: 'Upload a photo',
  Name: 'First name',
  LastName: 'Last name',
  Email: 'Email',
  Phone: 'Phone',
  HowToGetIt: 'How to get it?',
  UserType: 'User type',
  placeholderName: "User's name",
  placeholderLastName: "User's last name",
  placeholderEmail: "User's email",
  placeholderSlackId: "User's Slack ID (optional)",

  // Mailing
  ProcessingMail: 'In process email',
  RejectingMail: 'Rejection email',
  AcceptingMail: 'Acceptance email',
  titleTemplateMail: 'Post Templates',
  // modalChangeEmailBody
  EditEmailBody: 'Edit email body',
  ImportantInfo: 'Important info',
  Company: 'Company',
  Applicant: 'Applicant',

  // Test
  testQuestion: 'Question',
  testImg: 'Image',
  testOptional: 'Optional',
  testType: 'Type',
  testTime: 'Time',
  testAnswer: 'Correct Answer',
  // Kind of questions
  // Admin
  testTemplateMenu: 'Custom Questions',
  testTemplateTitle: 'Quiz Templates',
  testTemplateName: 'Template Name',
  templateNPSTitle: 'Satisfaction surveys (NPS)',
  templateNPSButton: 'Create New',
  templateNPSEliminar: 'Delete',
  // Jobs
  testImportTemplate: 'Do you want to import a template?',
  testOpenQuestion: 'Open question',
  testLongAnswer: 'Open Question (Long Answer)',
  testClosedQuestion: 'Closed Question (Yes and No)',
  testMultipleChoiceQuestion: 'Multiple Choice Question',
  testQuestionAboutRanks: 'Question about Ranks',
  QuestionType: 'Question Type',
  testOption: 'Option',
  addImgTest: 'Add image for question.',
  buttonNewTest: 'Add Custom Questions',
  buttonUpdateTest: 'Update Custom Questions',
  QuestionsPersonal: 'Custom Questions',
  QuestionsPersonalH2: 'Your questions',
  QuestionsEditorH2: 'Question creator',
  QuestionsWill: 'Your questions will appear here',
  // Modal Save Test
  modalSaveTest: 'Template name',
  addSaveTest: 'Save',
  updateSaveTest: 'Update',
  addCancelTest: 'Cancel',
  SelectAnAnswer: 'Select an answer',
  // NPS
  titleLayout: 'Layout',
  titleImg: 'Picture',
  titlePosition: 'Position',
  // Color
  colorQuestion: 'Questions',
  colorAnswer: 'Answer',
  typeQuestion: 'Type Question',
  typeInputQuestion: 'Type your answer here ...',
  npsYes: 'Yes',
  npsNo: 'No',
  npsChose: 'choice',
  npsAddChoice: 'Add choice',
  npsTitleSettings: 'Settings',
  npsProgressBar: 'Progress Bar',
  npsNavigationArrows: 'Navigation Arrows',
  npsRedirect: 'Redirect',
  // Notificaciones de Test Personalizado
  notificationOptionAnswer: 'At least 2 options are requested to be a closed question and select an answer',
  notificationAddTest: 'Your personal questionnaire was saved.',
  notificationErrorTest: 'A name is required for the template.',
  notificationSuccessTestUpdate: 'Updated Test Template.',
  notificationErrorTestUpdate: 'Failed to save template.',
  // Big Brother HH
  bigBrotherTitle: 'Big Brother HH',
  labelCompanyName: 'Company Name',
  labelCompanyEmail: 'Public email',
  labelSiteWeb: 'Site web',
  labelCompanyPhone: 'Phone',
  labelCompanyLocation: 'Location',
  labelCompanyDescription: 'About',
  labelCompanyData: 'A little history',
  labelCompanyLogo: 'Add company logo',
  labelImgVacancy: 'Add vacancy image',
  SelectCompany: 'Select company template',
  labelChangeImg: 'Drag and drop logo here or click to select logo',

  // Score criteria with weight
  ScoreCriteria: 'Score criteria',
  TemplateNameCriteria: "Template's name",
  CriterionName: "Criterion's name",
  CriterionWeight: "Criterion's weight",
  AddCriterion: 'Add criterion',
  Weight: 'Weight',
  NameCriterionHeader: 'Name',
  TemplateUpdated: 'Template updated',
  TemplateSaved: 'Templaate saved',
  ErrorWhileUpdating: 'Failed to update the template',
  WeightInvalidValue: 'Weight value must be between 0.1 and 10',

  // Notifications
  LettersNotAllowed: 'Letters are not allowed',
  SubdomainEmpty: 'Subdomain field is empty',
  DistinctSubdomain: 'Use a different subdomain than the previous one',
  OnlySubdomainAllowed: 'Only subdomain is allowed',
  UpdateSuccessfullyDone: 'Update succesfully done',
  CouldNotMoveColumn: 'Could not move the column, try again',
  TemplateDeleted: 'Template deleted',
  Only10Values: 'You can select only 10 values',
  ValuesUpdated: 'Values updated',
  SendingInfo: 'Sending info...',
  MustFillAllFields: 'You must fill all fields',
  IntegrationError: 'Invalid key, the key must have 40 characters',
  IntegrationSuccess: 'Integration done successfully!',

  // Grids
  emptyTest: 'There is no data available',
  publish: 'To post',
};
